import { createActions } from 'redux-actions';

import { GetCorporateHealthOrderParams } from '@apis/CorporateHealthOrderApi';
import { CorporateHealthOrder } from '@models/CorporateHealthOrder';

export type State = {
  corporateHealthOrder?: CorporateHealthOrder | null;
};

export type CorporateHealthOrderFetchPayload = GetCorporateHealthOrderParams;
export type StateUpdatePayload = Partial<State>;

export const {
  corporateHealthOrderFetch,
  stateUpdate,
} = createActions(
  'CORPORATE_HEALTH_ORDER_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_CORPORATE_HEALTH_POLICY_DETAILS',
  },
);
